// extracted by css-extract-rspack-plugin
export default {"join-waitlist":"JoinWaitlist-module__join-waitlist--T9xzN"};